module.exports = __webpack_public_path__ + "static/img/2.54b071da.png";